function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.5,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16308",
    d: "m10.262 8 5.269-5.269A1.6 1.6 0 1 0 13.269.469L8 5.737 2.731.469A1.6 1.6 0 1 0 .469 2.731L5.737 8 .469 13.269a1.6 1.6 0 1 0 2.263 2.262L8 10.263l5.269 5.269a1.6 1.6 0 1 0 2.262-2.262z",
    transform: "translate(.25 .25)",
    style: {
      fill: "#e55451",
      stroke: "#e55451",
      strokeWidth: ".5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.c61e8800590fe73c34a171c48ebf5c0d.svg";
export { ForwardRef as ReactComponent };